<template>
	<card layout="grid" tag="section">
		<template #default>
			<div class="widget-container">
				<loading v-if="loading"></loading>
				<div v-else class="partner-info is-flex" v-for="(a, i) in assignments" :key="i">
					<div v-for="(u, j) in a.users" :key="j">
						<user-picture :user="u" size="micro"></user-picture>
					</div>
					<div class="is-flex is-flex-direction-column mt-2 ml-4" v-if="!loading">
						<h3>{{ a.company }}</h3>
						<div>
							{{ a.jobTitle }}
						</div>
						<div class="mt-5">
							<router-link
								target="_blank"
								class="button is-small is-light"
								:to="{ name: '_assignmentDetail', params: { Id: a.Id } }">
								View assignment
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</template>
	</card>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import { userPicture } from "@/components/webComponents";
	// import { skeletonDetail } from "@/components/webComponents/template";
	import { objectUtils } from "@/services/utils";

	export default {
		props: {
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		components: {
			userPicture
			//skeletonDetail
		},
		setup(props, context) {
			const $http = inject("$http");

			const loading = ref(true);
			const assignments = ref();

			const GetRecentTeamingWin = async () => {
				loading.value = true;
				try {
					const response = await $http.post("/api/v2/widget/recentTeamingWin" + "?take=1", {
						filter: props.filters
					});
					assignments.value = response.data.map((assn) => {
						assn.users = objectUtils.toCamelCase(JSON.parse(assn.users || "[]"));
						return assn;
					});
				} catch (err) {
					console.error(err);
					loading.value = false;
				}
				loading.value = false;
			};

			onMounted(() => {
				GetRecentTeamingWin();
			});

			return {
				loading,
				assignments
			};
		}
	};
</script>
